import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store, persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom'
import './components/fonts/Gerbera-Light.ttf'
import './components/fonts/Gerbera-Medium.ttf'
import './components/fonts/Gerbera-Bold.ttf'
import { TrackingProvider, TypeFamily } from '@facephi/sdk-web'
import { PrimeReactProvider, PrimeReactContext } from 'primereact/api'
import "primereact/resources/themes/lara-light-cyan/theme.css";



ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <PrimeReactProvider>
            <TrackingProvider
              // trackingUrl={''}
              clientId={'h5x3UWK1LMZEWCQ7KDIUss2Kguy0wuf6'}
              clientSecret={'h5x3UWK1LMZEWCQ7KDIUss2Kguy0wuf6'}
              tenantId={'42467279-6a56-43e4-b0c9-3fb8b4147bbb'}
              type={TypeFamily.onboarding}
              disabled={false}>
              <App />
            </TrackingProvider>
          </PrimeReactProvider>
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// basename="/easypayapp"
